//  isClient, CheckProfileCompletionCompany,
import jwt_decode from "jwt-decode";
import router from "@/router/router";
import store from '@/store';
import { requestNotificationPermission } from "@/firebase";
import {
    login,
    loginDelivery,
    register,
    VerifToken,
    isSupplier,
    CheckProfileCompletionSupplier,
    updateUserToken
    
} from "@/api/index";
import axios from "axios";
function routeUserBasedOnProfileCompletion(url) {
    if (isSupplier()) {
        CheckProfileCompletionSupplier().then((resp) => {
            if (resp.data == true) {
                router.push("/supplier");
            } else {
                router.push(url);
            }
        });
    } else {
        router.push(url);
    }
}
export default {
    async login(context, payload) {
        await login(payload).then(async (res) => {
            let token = res.data;
            localStorage.setItem("accessToken", token);
            var decoded = jwt_decode(token);
            localStorage.setItem("Name", decoded.UserName);
            localStorage.setItem("UserId", decoded.UserId);
            axios.defaults.headers.common["Authorization"] = "Bearer " + token;
            context.commit("setUser", {
                token: token,
                userName: decoded.UserName,
            });
            VerifToken();
            requestNotificationPermission().then((currentToken) => {
                if (currentToken) {
                    updateUserToken(currentToken);
                }
            })
            routeUserBasedOnProfileCompletion("/PurchaseOrder");
        }).catch(error => {
            throw error;
        });
    },
    async loginDelivery(context, payload) {
        await loginDelivery(payload).then((res) => {           
            let token = res.data.token;
            localStorage.setItem("accessMode", "Delivery");
            localStorage.setItem("accessToken", token);
            var decoded = jwt_decode(token);
            localStorage.setItem("Name", decoded.UserName);
            localStorage.setItem("UserId", decoded.UserId);
            axios.defaults.headers.common["Authorization"] = "Bearer " + token;
            context.commit("setUser", {
                token: token,
                userName: decoded.UserName,
            });
            VerifToken();
            routeUserBasedOnProfileCompletion("/");
        }).catch(error => {
            throw error;
        });
    },

    tryLogin(context) {
        const token = localStorage.getItem("accessToken");
        const userName = localStorage.getItem("Name");
        if (token && userName) {
            context.commit("setUser", {
                token: token,
                userName: userName,
            });
            
            let url = window.location.pathname || "/PurchaseOrder";            
            routeUserBasedOnProfileCompletion(url);
        }
    },
    logout(context) {
        context.commit("setUser", {
            token: null,
            userName: null,
        });
    },
    async signup(_, payload) {
        await register(payload);
    },
    setLtsNotification(context, payload) {
         context.commit("setLtsNotification", [...store.getters.ltsNotification, payload]);
    },
    setLtsNotificationToEmpty(context) {
        context.commit("setLtsNotification", []);
   }
};
